import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Space, Typography } from 'antd';
import { CSSProperties } from 'react';

const { WEBAPP_BASE_URL } = ENV_CONFIG_VARS;

interface ProfileNameMenuProps {
    profileId: string;
    firstName: string;
    lastName: string;
    titleStyle?: CSSProperties;
}

export default function ProfileNameMenu({
    profileId,
    firstName,
    lastName,
    titleStyle,
}: ProfileNameMenuProps) {
    return (
        <Dropdown
            menu={{
                items: [
                    {
                        label: (
                            <a
                                href={`${WEBAPP_BASE_URL}/site/nurse/${profileId}`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                View Profile
                            </a>
                        ),
                        key: 'profile',
                    },
                    {
                        label: (
                            <a
                                href={`${WEBAPP_BASE_URL}/site/impersonate/${profileId}`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                Impersonate
                            </a>
                        ),
                        key: 'impersonate',
                    },
                ],
            }}
        >
            <a>
                <Space>
                    <Typography.Title level={4} style={titleStyle}>
                        {`${firstName} ${lastName}`} <DownOutlined />
                    </Typography.Title>
                </Space>
            </a>
        </Dropdown>
    );
}
